import Page from '../../components/page';
import { useDialog } from '../../hook/use-dialog';
import { BrowseAPIDialog } from './browse';
import { Grid } from './grid';

function ApiRecord() {
	const [BrowseDialog, openBrowseDialog] = useDialog(BrowseAPIDialog);

	return (
		<Page>
			<Grid openBrowseDialog={openBrowseDialog} />
			<BrowseDialog data={{}} />
		</Page>
	);
}

export default ApiRecord;
